import { render, staticRenderFns } from "./customInput.vue?vue&type=template&id=d38f2a1c&scoped=true"
import script from "./customInput.vue?vue&type=script&lang=js"
export * from "./customInput.vue?vue&type=script&lang=js"
import style0 from "./customInput.vue?vue&type=style&index=0&id=d38f2a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38f2a1c",
  null
  
)

export default component.exports